import { FaPlus } from "react-icons/fa6";

export const PlusIcon = ({ ...rest }) => {
  return <FaPlus {...rest} />;
};
